import { Component, Input } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { LocaldataService } from '../service/localdata/localdata.service';


import { LaaneoversigtPage } from '../pages/laaneoversigt/laaneoversigt.page';
import { AuthService } from '../service/auth/auth.service';

import { BackgroundColorOptions, StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { RentalagreementAcceptPage } from '../pages/forms/rentalagreement-accept/rentalagreement-accept.page';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tab1',
  templateUrl: 'tab1.page.html',
  styleUrls: ['tab1.page.scss']
})
export class Tab1Page  {

  rentalAgreements: any[] = [];

  private displayName: string;

  public mainnav: boolean;
  //@Input() mainnav: boolean;

  constructor(public localData: LocaldataService, private auth: AuthService, private alertCtrl: AlertController, private modalCtrl: ModalController, private router: Router, private activatedRoute: ActivatedRoute) {
    this.mainnav=false;
  }
change(){
  this.mainnav=!this.mainnav
}

navigateToComponentAndRetainTabs(){
  this.router.navigate(['../danskkartoffelstivelse'], { relativeTo: this.activatedRoute });
}

async showRentalAgreement (agreement){
  
  agreement['actionIdParameter'] = agreement.id;
  console.log(agreement)
  let modal = await this.modalCtrl.create({
    component: RentalagreementAcceptPage,
    componentProps: {
      modalCtrl: this.modalCtrl,
      notification: agreement
    },
    backdropDismiss: true,
  });

  await modal.present();

  modal.onDidDismiss().then((result) => {
    console.log(result.data)
    
    if (result.data) {
      this.removeRentalAgreement(result.data);
    }
  });

}

removeRentalAgreement(id: string) {
  this.rentalAgreements = this.rentalAgreements.filter(agreement => agreement.id !== id);
  this.loadRentalAgreements();
}

loadRentalAgreements() {
  this.localData.getRentalAgreementsByUserId().subscribe(
    data => {
      this.rentalAgreements = data;
    },
    error => {
      console.error('Error fetching rental agreements', error);
    }
  );
}

  ionViewDidEnter() {
    this.localData.checkVersionUpdate();

    this.loadRentalAgreements()

    this.mainnav=false;

    this.displayName = this.auth.userProfile.displayname;
    

    if (Capacitor.isPluginAvailable('StatusBar')) {
      StatusBar.setOverlaysWebView({ overlay: false });
      StatusBar.setBackgroundColor({color:'#59A8C7'});
    }
  }

  ionViewDidLeave() {
    this.mainnav=false;
  }



  async doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    const tsBegin = Date.now();
    const tsEnd = Date.now();
      const delay = ((tsEnd-tsBegin)<500) ? 500 - (tsEnd-tsBegin) : 0;


    this.localData.remoteUpdateNotifications().then(()=>{

      const tsEnd = Date.now();
      const delay = ((tsEnd-tsBegin)<500) ? 500 - (tsEnd-tsBegin) : 0;

      console.log('delay', delay);

      setTimeout(() => {
        console.log('Async operation has ended');
        refresher.target.complete();
      }, delay);


    }).catch(() => {console.log('ERROR');})
  }

  async alert(){
    let alert = await this.alertCtrl.create({
        header: 'Use this lightsaber?',
        message: this.auth.userProfile.displayname,
        buttons: ['Agree'],
      });

      await alert.present();
    
  }
  currentModal = null;

  async openForm(){
    
    let modal = await this.modalCtrl.create({
      component: LaaneoversigtPage,
      componentProps: {
        modalCtrl: this.modalCtrl
      },
      backdropDismiss: false,
    });
    return await modal.present();
    this.currentModal = modal;
  }

  async dismissModal() {
    if (this.currentModal) {
      this.currentModal.dismiss().then(() => {
        this.currentModal = null;
      });
    }
  }

}
